// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GsjUX","index":"styles_index__II--Q"};